/* @flow weak */
import { Record } from '../transit'

const State = Record({
  appName: 'Vobo',
  appVersion: '1.0',
  sentryUrl: '',
}, 'config')

const configReducer = (state = new State()) => state

export default configReducer



// WEBPACK FOOTER //
// ./src/common/config/reducer.js